/**
 * Player movie info snippet
 * 
 * @author Mautilus s.r.o.
 * @class Snippet_PlayerMovieInfo
 * @extends Snippet
 */

Snippet_PlayerMovieInfo = (function(Snippet) {

	var Snippet_PlayerMovieInfo = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_PlayerMovieInfo.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config){
			this.$lastFocused = null;
			
			// this.$pausedState = this.$el.find('.paused-state');
			this.$tags = this.$el.find('.tags');
			this.$title = this.$el.find('.title');
			this.$metadata = this.$el.find('.metadata');
			// this.$rating = this.$el.find('.rating');
			this.$description= this.$el.find('.description');
		},
		
		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#snippet-player-movie-info");
			}
		},
		
		/**
		 * @inheritdoc Snippet#render
		 * @param {Object} movie (Asset Model)
		 */
		render: function(movie) {
			this.clear();
			
			// make HTML template
			var html = this.getTemplates(movie);
			
			// append HTML to DOM
			this.$title.html(html.title);
			this.$tags.html(html.tags);
			this.$metadata.html(html.metadata);
			// this.$rating.html(html.rating);
			this.$description.html(html.description);
		},
		
		onLangChange: function () {
			// this.$pausedState.html(__("paused"));
		},
		
		/**
		 * To get HTML template
		 * @param {Object} movie (Asset Model)
		 * @return {Object.String} html template
		 */
		getTemplates: function( movie ) {
			var html = {
				title: '',
				tags: '',
				metadata: [],
				description: ''
			};

			if ( Player.config.videoType === 'trailer' || Player.config.videoType === 'movie' ) {

				html.title = movie.get('title') || '';

				var genres = movie.get('genres');
				for ( var i = 0; i < genres.length; i++ ) {
					html.tags += '<div class="genre">' + genres[i] + '</div>';
				}

				var parentalControl = movie.getParentalGuidanceLabel();
				if ( parentalControl ) {
					html.tags += '<div class="parentalControl">' + parentalControl + '</div>';
				}

				var metadata = [];
				if ( movie.get( 'year' ) ) {
					metadata.push( movie.get( 'year' ) );
				}
				if ( movie.getDuration() ) {
					metadata.push( ( movie.getDuration() / 60 ).toFixed( 0 ) + __( 'min' ) );
				}
				html.metadata = metadata.join(', ');

				var description = movie.get('synopsis'), len = 520;
				if ( description && description.length > len ) {
					description = description.substring( 0, len ) + '...';
				}
				html.description = description;

			} else if ( Player.config.videoType === 'episode' ) {

				if ( !!movie.title ) {
					html.title = movie.title.en_US;
				}

				if ( !!movie.parentalGuidance ) {
					html.tags += '<div class="parentalControl">' + movie.parentalGuidance + '</div>';
				}

				if ( !!movie.duration ) {
					html.metadata = ( movie.duration / 60 ).toFixed( 0 ) + __( 'min' );
				}

				if ( !!movie.synopsis ) {
					var description = movie.synopsis.en_US, len = 520;
					if ( description && description.length > len ) {
						description = description.substring( 0, len ) + '...';
					}
					html.description = description;
				}
			}

			return html;
		},

		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function($el, event) {
			return false;
		},
		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function(direction) {
			if (direction == "up")         { this.trigger("focus:out", this, direction); }
			else if (direction == "down")  { this.trigger("focus:out", this, direction); }
			else if (direction == "left")  { this.trigger("focus:out", this, direction); }
			else if (direction == "right") { this.trigger("focus:out", this, direction); }
			return false;
		},
		
		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function($el) {
			if(!$el) {
				$el = this.getFocusable(0);
			}
			return Focus.to($el);
		},
		
		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function($el) {
			this.$lastFocused = $el;
		},
		
		clear: function(light) {
			this.$lastFocused = null;

			this.$title.html('');
			this.$tags.html('');
			this.$metadata.html('');
			// this.$rating.html('');
			this.$description.html('');
		}
	});

	return Snippet_PlayerMovieInfo;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/player_movie_info.js
// module id = 71
// module chunks = 0